import {
  CompletionRange,
  CompletionSummary,
  IncompleteField,
  ProfileCompletion,
  Range,
  TimeSeries,
  TimeSeriesData,
} from '../../../entities/insights/spotlight-directories/profile-completion.model';

const getDefaultRange = (): Range => ({
  start: 0,
  end: 25,
});

const getDefaultCompletionRange = (): CompletionRange => ({
  range: getDefaultRange(),
  percentage: 10.1,
  count: 3000,
});

const getDefaultCompletionSummary = (): CompletionSummary => ({
  ranges: [
    getCompletionRange({
      range: getRange({ start: 0, end: 25 }),
      percentage: 10.1,
      count: 3000,
    }),
    getCompletionRange({
      range: getRange({ start: 26, end: 50 }),
      percentage: 19.0,
      count: 15000,
    }),
    getCompletionRange({
      range: getRange({ start: 51, end: 75 }),
      percentage: 31.6,
      count: 22000,
    }),
    getCompletionRange({
      range: getRange({ start: 76, end: 99 }),
      percentage: 27.8,
      count: 30000,
    }),
    getCompletionRange({
      range: getRange({ start: 100, end: 100 }),
      percentage: 11.4,
      count: 40000,
    }),
  ],
  total_profiles: 115000,
  incomplete_profiles: 75000,
  incomplete_percentage: 65.2,
});

const getDefaultIncompleteField = (): IncompleteField => ({
  field: 'work_experience',
  incomplete_count: 30000,
  incomplete_percentage: 70.0,
});

const getDefaultTimeSeriesData = (): TimeSeriesData => ({
  period: '2024-01',
  overall_completion_percentage: 52.3,
});

const getDefaultTimeSeries = (): TimeSeries => ({
  grouping: 'monthly',
  data: [
    getTimeSeriesData({
      period: '2024-01',
      overall_completion_percentage: 52.3,
    }),
    getTimeSeriesData({
      period: '2024-02',
      overall_completion_percentage: 54.1,
    }),
    getTimeSeriesData({
      period: '2024-03',
      overall_completion_percentage: 57.8,
    }),
  ],
});

const getDefaultProfileCompletion = (): ProfileCompletion => ({
  overall_completion_percentage: 59.1,
  completion_summary: getDefaultCompletionSummary(),
  most_incomplete_fields: [
    getIncompleteField({
      field: 'work_experience',
      incomplete_count: 30000,
      incomplete_percentage: 70.0,
    }),
    getIncompleteField({
      field: 'linkedin',
      incomplete_count: 28100,
      incomplete_percentage: 68.5,
    }),
    getIncompleteField({
      field: 'twitter',
      incomplete_count: 27250,
      incomplete_percentage: 67.2,
    }),
  ],
  time_series: getDefaultTimeSeries(),
});

export const getRange = (range?: Partial<Range>): Range => ({
  ...getDefaultRange(),
  ...range,
});

export const getCompletionRange = (
  completionRange?: Partial<CompletionRange>,
): CompletionRange => ({
  ...getDefaultCompletionRange(),
  ...completionRange,
});

export const getCompletionSummary = (
  completionSummary?: Partial<CompletionSummary>,
): CompletionSummary => ({
  ...getDefaultCompletionSummary(),
  ...completionSummary,
});

export const getIncompleteField = (
  incompleteField?: Partial<IncompleteField>,
): IncompleteField => ({
  ...getDefaultIncompleteField(),
  ...incompleteField,
});

export const getTimeSeriesData = (timeSeriesData?: Partial<TimeSeriesData>): TimeSeriesData => ({
  ...getDefaultTimeSeriesData(),
  ...timeSeriesData,
});

export const getTimeSeries = (timeSeries?: Partial<TimeSeries>): TimeSeries => ({
  ...getDefaultTimeSeries(),
  ...timeSeries,
});

export const getProfileCompletion = (
  profileCompletion?: Partial<ProfileCompletion>,
): ProfileCompletion => ({
  ...getDefaultProfileCompletion(),
  ...profileCompletion,
});

export const getProfileCompletions = (): ProfileCompletion[] => [
  getProfileCompletion(),
  getProfileCompletion({
    overall_completion_percentage: 65.4,
    completion_summary: getCompletionSummary({
      total_profiles: 85000,
      incomplete_profiles: 55000,
      incomplete_percentage: 64.7,
    }),
  }),
];
